import axios from "@/http";

class Personalization {
  // 设置用户个性化设置
  static postSetUserPersonalization(data) {
    const url = "/oa/api/pc/manager/save/personal/setting";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Personalization;